// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyD3ACfJk1RyPfxdyX672-Na_HSu5EP9auc",
    authDomain: "the-crumb-wallet-explorer.firebaseapp.com",
    projectId: "the-crumb-wallet-explorer",
    storageBucket: "the-crumb-wallet-explorer.firebasestorage.app",
    messagingSenderId: "61147458840",
    appId: "1:61147458840:web:25613fc62583cfbc56c26d"
};

export const app       = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);


export default app;
